const RESPONSIBLE_PERSON_COLUMNS = {
  id: 'Id',
  label: 'Label',
  name: 'Name',
  countryCode: 'Country code',
  street: 'Street',
  postalCode: 'Postal code',
  city: 'City',
  email: 'Email',
  phoneNumber: 'Phone number',
  formUrl: 'Form URL',
} as const;

export default RESPONSIBLE_PERSON_COLUMNS;
